module.exports = __webpack_public_path__ + "static/img/case_img01.7b16fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/case_img01.png
// module id = mLlt
// module chunks = 1